import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import {
  resetSpeakToAConsultantSuccess,
  sendSpeakToAConsultant,
} from "../../features/speakToAConsultant/speakToAConsultant.slice";
import { Report } from "../../libs/loggers";
import PrimaryButton from "../ui/buttons/primaryButton";
import Form from "../ui/forms";
import Input from "../ui/forms/fields/input";
import SpeakToAConsultantFeedback from "./SpeakToAConsultantFeedback";
import { useNavigate } from "react-router-dom";
import { resetSubmition } from "../../features/submition/submition.slice";
import { resetData } from "../../features/data/data.slice";

import { resetUser } from "../../features/user/user.slice";
import { resetSteps } from "../../features/stepper.slice";

const schema = yup.object().shape({
  message: yup.string().required("Message is required"),
  name: yup.string().required("Name is required"),
  surname: yup.string().required("Surname is required"),
  email: yup.string().required("Email is required"),
  phone: yup.string().required("Phone is required"),
});

function ContactUsDialog({ open, onClose, selectedVehicle }) {
  const {
    control,
    handleSubmit,
    register,
    reset,
    trigger,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const [alertOpen, setAlertOpen] = useState(false);
  const [openContactUs, setOpenContactUs] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const success = useSelector(
    (state) => state.speakToAConsultant.speakToAConsultantSentSuccess
  );
  const loading = useSelector((state) => state.speakToAConsultant.loading);

  const [dialogOpen, setDialogOpen] = useState(false);
  const stepper = useSelector((state) => state.stepper.value);
  let page = window.location.pathname.replace(/^\/|\/$/g, "");

  const handleAlertClose = () => {
    onClose();
    setAlertOpen(false);
  };

  const handleClose = () => {
    setDialogOpen(false);
    onClose();
    if (success) {
      navigate(stepper.steps[0].url);
      dispatch(resetSubmition());
      dispatch(resetData());
      dispatch(resetSteps());
      dispatch(resetUser());
    }
  };

  const handleContactUsSubmit = async () => {
    const isValid = await trigger();
    if (isValid) {
      const formData = getValues();

      setAlertOpen(true);
      Report({
        action: "submit",
        category: "help",
        description: "clicked submit on speak to a consultant dialog",
        value: {
          ...formData,
          currentPage: page,
          step: stepper.active + 1,
          value: `speak_to_a_consultant`,
        },
      });

      await dispatch(sendSpeakToAConsultant({ ...formData }));
      setDialogOpen(true);
      reset();
      setOpenContactUs(false);
    }
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        open={open}
        onClose={onClose}
        PaperProps={{ style: { padding: "24px", borderRadius: "30px" } }}
      >
        <Typography pl={3} pt={3} variant="h3" fontWeight={500}>
          Contact Us
        </Typography>
        <IconButton
          aria-label="close"
          color="primary"
          size="large"
          onClick={onClose}
          sx={{ position: "absolute", top: 0, right: 0 }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
        <DialogContent>
          The ability for you to invest in this product through our online
          digital automation investment process is{" "}
          <span style={{ fontWeight: 500 }}>coming soon.</span> Fairtree does
          however have all products listed on this screen available for you to
          invest in.
          <br />
          <br />
          Should you wish to invest, one of our consultants would be happy to
          help you.
          <br />
          <br />
          <Form>
            <Typography variant="h6" sx={{ mt: 2 }}>
              Please tell us how we can help you:
            </Typography>
            <Input
              {...register("message")}
              label="Type your message here..."
              multiline
              rows={3}
              error={!!errors.message}
              helperText={errors?.message?.message}
            />
            <br />
            <Input
              readOnly
              InputLabelProps={{ shrink: true }}
              {...register("vehicle")}
              label="Product"
              value={selectedVehicle ? selectedVehicle.name : ""}
              helperText={"Read Only"}
            />
            <br />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Please provide us with your:
            </Typography>
            <Input
              {...register("name")}
              label="Name"
              error={!!errors.name}
              helperText={errors?.name?.message}
            />
            <Input
              {...register("surname")}
              label="Surname"
              error={!!errors.surname}
              helperText={errors?.surname?.message}
            />
            <Input
              {...register("email")}
              label="Email"
              error={!!errors.email}
              helperText={errors?.email?.message}
            />
            <Input
              {...register("phone")}
              label="Phone"
              error={!!errors.phone}
              helperText={errors?.phone?.message}
            />
          </Form>
        </DialogContent>
        <DialogActions>
          <PrimaryButton
            sx={{ borderRadius: "30px" }}
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </PrimaryButton>
          <PrimaryButton
            onClick={handleContactUsSubmit}
            sx={{ borderRadius: "30px" }}
          >
            Submit
          </PrimaryButton>
        </DialogActions>
      </Dialog>

      <SpeakToAConsultantFeedback
        open={dialogOpen}
        onClose={handleClose} // this now closes both dialogs
        loading={loading}
        success={success}
      />
    </>
  );
}

export default ContactUsDialog;
